import PropTypes from 'proptypes';
import checkIcon from '../../assets/images/svg/check-white.svg';
import './status.css';

function Status(props) {
  const { text, progress } = props;
  return (
    <div className={`status ${progress}`}>
      {checkIcon && (
        <img src={checkIcon} alt="checkIcon" className="checkIcon" />
      )}
      <p className="text">{text || ''}</p>
    </div>
  );
}

Status.prototype = {
  /**
   * text to be shown on p
   */
  text: PropTypes.string.isRequired,

  /**
   * custom class to be used for styling
   */
  progress: PropTypes.string.isRequired
};

export default Status;
